import { render, staticRenderFns } from "./OptionImage.vue?vue&type=template&id=e90088bc&scoped=true&"
import script from "./OptionImage.vue?vue&type=script&lang=js&"
export * from "./OptionImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90088bc",
  null
  
)

export default component.exports